const config = {
    cacheKey:{
        userToken:'user_token',
        userInfo:'user_info',
    },
    version:'CoreHalo Guide 1.0',
    versionCode:20250305,
    apiDomain:"https://api.corehalo.com/api/guide",
    apiOriginDomain:"https://api.corehalo.com/api/app.v3",
};

export default config;